import _default from './Placeholder';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Placeholder/index.js
// module id = 658
// module chunks = 0